import styled from "@emotion/styled"
import { Form } from "formik"
import { theme } from "../../utils/theme"
import { Button } from "../basic"
import { Field } from "./field"

export const SecureForm = styled(Form)`
  padding-bottom: 2rem;

  label {
    font-weight: 600;
  }

  .hidden-field {
    position: absolute;
    left: -5000px;
  }
`

export const SecureField = styled(Field)`
  margin-bottom: 1rem;
`

export const VerificationRow = styled.div`
  margin-top: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;

  @media (max-width: 520px) {
    align-items: stretch;
  }
`

export const VerificationWidget = styled.div`
  flex: 0 0 auto;
`

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const PrimarySubmitButton = styled(Button)`
  color: #ffffff;
  border-color: ${theme.colors.primary};
  background-color: ${theme.colors.primary};
  padding: 0.8rem 1.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 6px 16px rgba(62, 149, 179, 0.3);
  transition: transform 0.15s ease, box-shadow 0.15s ease,
    background-color 0.2s ease;

  span {
    font-size: 1rem;
    font-weight: 600;
    background-image: none;
  }

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 22px rgba(62, 149, 179, 0.35);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 4px 12px rgba(62, 149, 179, 0.25);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: 0 2px 8px rgba(62, 149, 179, 0.15);
  }

  &:disabled:hover,
  &:disabled:active {
    transform: none;
    box-shadow: 0 2px 8px rgba(62, 149, 179, 0.15);
  }
`
